import { Injectable } from '@angular/core';

export enum SessionKeyOptions {
  Admin = "Admin",
  Package = "Package",
  PackageId = "PackageId"
}


@Injectable({
  providedIn: 'root'
})
export class SessionService {

  setItem(key: SessionKeyOptions, value: any) {
    sessionStorage.setItem(key.toString(), JSON.stringify(value));
  }

  getItem(key: SessionKeyOptions): any {
    return JSON.parse(sessionStorage.getItem(key.toString()));
  }
}
